import dayjs from 'dayjs'
/**
 * 数据存储方式
 */
export const storage = {
  setItem (key, value) {
    key && value && sessionStorage.setItem(key, value)
  },
  getItem: (key) => {
    return (key && sessionStorage.getItem(key)) || ''
  },
  removeItem: (key) => {
    key && sessionStorage.removeItem(key)
  },
  clear: () => {
    sessionStorage.clear()
  }
}

export const day = {
  now: () => {
    return dayjs()
  },
  nowF: (format = 'YYYY-MM-DD') => {
    return dayjs().format(format)
  },
  format: (value, format = 'YYYY-MM-DD') => {
    return dayjs(value).format(format)
  }
}
export function throttle (fn, interval = 200) {
  var last
  var timer
  return function () {
    var th = this
    var args = arguments
    var now = +new Date()
    if (last && now - last < interval) {
      clearTimeout(timer)
      timer = setTimeout(function () {
        last = now
        fn.apply(th, args)
      }, interval)
    } else {
      last = now
      fn.apply(th, args)
    }
  }
}

export const tool = {
  randomString: (len) => {
    len = len || 32
    var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678' /** **默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
    var maxPos = $chars.length
    var pwd = ''
    for (let i = 0; i < len; i++) {
      pwd += $chars.charAt(Math.floor(Math.random() * maxPos))
    }
    return pwd
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js